import React from "react";
import Footer_content from "./content";
import Footer_copyright from "./copyright";

function Footer(){

    return(
        <footer className="mainFooter">
            <Footer_content />
            <Footer_copyright />
        </footer>
    );

}

export default Footer;